export const ACTIVATE_ACCOUNT_HISTORY = 'page/ACCOUNT_HISTORY [activate]';
export const LEAVE_ACCOUNT_HISTORY = 'page/ACCOUNT_HISTORY [leaving]';

export const ACCOUNT_HISTORY_READY = 'page/ACCOUNT_HISTORY_DATA [done]';
export const ACCOUNT_HISTORY_DATA_LOADING =
    'page/ACCOUNT_HISTORY_DATA [loading]';
export const ACCOUNT_HISTORY_DOWNLOAD = 'page/ACCOUNT_HISTORY_DOWNLOAD';
